<template>
  <div>
    <!-- Search -->
    <div class="row mt-4">
      <div class="col-md-8">
        <input
          class="input form-control"
          @keypress.enter="find()"
          v-model="query.generic"
          placeholder="Pesquisar"
        >
        <search-icon @click="find()" class="icon icon-within"/>
      </div>

      <button
        class="col-md-1 ml-2 btn-sm btn-outline"
        :class="{ 'btn-outline-active': showFilter }"
        @click="showFilter = !showFilter"
      >
        Filtros
        <chevron-down-icon class="fa-angle-right" :class="{'rotate-90': showFilter }"/>
      </button>

      <button v-if="changeQuery" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>

    <!-- Badges -->
    <div class="row">
      <div class="col-md-12">
        <BadgeFilters
          :query="query"
          @clearBadge="find()"
          @clearAllBadges="find()"
          :amount-changed="updateNumberOfBadges"
          :filters="badgeFilters"
        />
      </div>
    </div>

    <!-- Filters -->
    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-4">
          <label>Status</label>
          <input v-model="query.status" class="form-control" placeholder="Status">
        </div>

        <div class="col-md-4">
          <label for="item-start-date">Data inicial</label>
          <input v-model="query.startDate" type="date" id="item-start-date" class="form-control">
        </div>

        <div class="col-md-4">
          <label for="item-end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="item-end-date" class="form-control">
        </div>
      </div>
    </template>
    <hr>

    <!-- Info -->
    <div class="row mt-4">
      <div class="col-md-12">
        <strong class="mr-3">
          {{ infoTotalModels }}
        </strong>
      </div>
    </div>

    <!-- Table -->
    <div class="row flex-fill d-flex justify-content-start">
      <div class="col-md-12 mt-2">
        <table class="table table-borderless table-dfe">
          <thead>
            <tr>
              <th>ID</th>
              <th>Status</th>
              <th>Criado em</th>
              <th>Atualizado em</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in items" :key="item.id">
              <td>{{ item.id }}</td>
              <td>{{ item.status }}</td>
              <td>{{ item.createdAt | datetime }}</td>
              <td>{{ item.updatedAt | datetime }}</td>
              <td>
                <button @click="show(item)" class="btn btn-outline">
                  Detalhes
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-md-12 my-1">
        <Pagination
          v-model="meta.currentPage"
          :total-count="meta.totalCount"
          :total-pages="meta.totalPages"
          @pagination="pagination"
        />
      </div>
    </div>

    <ShowDataModal v-model="showModal" header="Item" :data="currentItem"/>
  </div>
</template>

<script>
import BadgeFilters from '@/components/shares/BadgeFilters'
import ModelMapper from '@/mixins/ModelMapper'

import Pagination from '@/components/shares/specialTag/Pagination'
import ShowDataModal from '@/components/admin/ShowDataModal'

import { ChevronDownIcon, SearchIcon } from 'vue-feather-icons'
import { Filter } from '@/models/filter'

export default {
  components: { BadgeFilters, ChevronDownIcon, Pagination, SearchIcon, ShowDataModal },
  computed: {
    currentAxios() {
      return this.axios.v3
    },
    items() {
      return this.getModels || []
    },
    badgeFilters() {
      return [
        this.filterStatus,
        this.filterEndDate,
        this.filterStartDate
      ]
    }
  },
  created() {
    this.addOrderBy('createdAt')

    const date = new Date()
    this.$set(this.query, 'startDate', date.toISOString().substring(0, 10))

    this.defaultModelSetting.updateQueryURL = true
    this.asyncTemplateSelect({
      byURL: true,
      pagination: true
    })
  },
  data: () => ({
    currentItem: {},
    filterEndDate: new Filter({
      key: 'endDate',
      label: 'Data final',
      type: 'date'
    }),
    filterStartDate: new Filter({
      key: 'startDate',
      label: 'Data inicial',
      type: 'date'
    }),
    filterStatus: new Filter({
      key: 'status',
      label: 'Status',
      type: 'text'
    }),
    nameModel: 'Item',
    showModal: false,
  }),
  methods: {
    buildPath() {
      return 'admin/doc-hub/items'
    },
    find() {
      this.asyncTemplateSelect()
    },
    show(item) {
      this.showModal = true
      this.currentItem = item
    },
  },
  mixins: [ModelMapper],
  name: 'DocHubItem',
}
</script>
